(ns common.advertiser-selection-ocp.view
  (:require ["@mui/material/Chip$default" :as Chip]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Typography$default" :as Typography]
            ["@mui/x-data-grid-premium" :refer [DataGridPremium]]
            [common.db.router :refer [pop-path]]
            [common.ocp.view :refer [defocp ocp]]
            [common.queries :refer [use-query]]
            [common.resource.query.advertiser :as q]
            [common.util :refer [spread-obj]]
            [common.widgets.data-grid :as dg]
            [re-frame.core :as rf]
            [reitit.frontend.easy :as rfe]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defui format-name
  [{:keys [name archived id]}]
  (let [{:keys [advertiser-id]} (use-subscribe [:url-context])]
    ($ Stack
       {:direction "row"
        :justifyContent "space-between"
        :alignItems "center"
        :spacing 1
        :sx #js {:width "100%"}}
       ($ Stack
          {:direction "row"
           :alignItems "center"
           :spacing 1}
          ($ Typography (cond-> {}
                          archived (assoc :sx #js {:color "text.disabled"})) name)
          (when archived
            ($ Chip {:label "Archived"})))
       (when (= advertiser-id id)
         ($ Icon {:color "success"} "check")))))

(def columns
  #js [#js {:type "string"
            :field "advertiserName"
            :headerName "Name"
            :valueGetter (fn [_value row ^js _column ^js _apiRef]
                           (:name row))
            :renderCell (fn [^js params]
                          ($ format-name (.-row params)))
            :flex 1
            :sortable true}
       #js {:type "boolean"
            :field "archived"
            :headerName "Archived"
            :valueGetter (fn [_value row ^js _column ^js _apiRef]
                           (:archived row))
            :sortable true}])

(def Toolbar
  (uix/as-react
   (fn [_]
     ($ dg/grid-toolbar {:sx #js {:px 1.25
                                  :py 2.5
                                  ".MuiFormControl-root" #js {:pb 0
                                                              :flex 1}}}))))

(defocp switch-advertiser-ocp :switch-advertiser-ocp/view
  {:position :left
   :disable-padding true}
  []
  (let [{:keys [data isFetching]} (use-query (q/advertisers-query))
        current-route (use-subscribe [:router/current-route])

        get-row-id (uix/use-callback (fn [row]
                                       (str (:id row) "-"
                                            ;; Temp fix for advertisers appearing
                                            ;; multiple times due to OS workspace mappings.
                                            (some-> (:osWorkspaceInfo row) :id)))
                                     [])]
    ($ ocp
       {:title "Select an Advertiser"}
       ($ DataGridPremium
          {:columns columns
           :loading isFetching
           :rows (to-array data)
           :getRowId get-row-id
           :onRowClick #(rf/dispatch [:ocp/close])

           :disableColumnResize true
           :disableColumnMenu true
           :hideFooter true

           :initialState #js {:sorting #js {:sortModel #js [#js {:field "archived" :sort "asc"}
                                                            #js {:field "advertiserName" :sort "asc"}]}
                              :columns #js {:columnVisibilityModel #js {"archived" false}}}

           :slots #js {:toolbar Toolbar
                       :cell dg/WithLinkCell}
           :slotProps #js {:baseTextField (spread-obj dg/grid-toolbar-outlined-input
                                                      #js {:autoFocus true})
                           :cell #js {:href-fn (fn [row]
                                                 (let [path-params (:path (:parameters current-route))
                                                       href (rfe/href (:name (:data current-route))
                                                                      (assoc path-params :advertiser-id (:id row)))]
                                                   (cond-> href
                                                     (:campaign-id path-params) pop-path
                                                     (:adset-id path-params) pop-path)))}}

           :sx #js {".MuiDataGrid-columnHeader .MuiBadge-badge" #js {:display "none"}}}))))
